var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',{attrs:{"justify":"start"}},[_c('v-col',{attrs:{"cols":"12","md":"6","lg":"3"}},[_c('autocomplete',{attrs:{"set-loading":_vm.setLoading}})],1),_c('v-col',{attrs:{"cols":"12"}},[_c('content-audit',{attrs:{"loading":_vm.loading}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }